import React from "react";
import { Helmet } from "react-helmet";
import Footer from "../components/Footer";
import Navbar from "../components/Navbar";
import "./all.sass";
import useSiteMetadata from "./SiteMetadata";
import { withPrefix } from "gatsby";
import TopLinkBar from "./TopLinkBar";

const TemplateWrapper = ({ children }) => {
  const { title, description } = useSiteMetadata();
  return (
    <div>
      <Helmet>
        <html lang="en" />
        <title>{title}</title>
        <meta name="description" content={description} />

        <link
          rel="apple-icon"
          sizes="180x180"
          href={`${withPrefix("/")}img/apple-icon.png`}
        />
        <link
          rel="icon"
          type="image/png"
          href={`${withPrefix("/")}img/favicon-96x96.png`}
          sizes="96x96"
        />
        <link
          rel="icon"
          type="image/png"
          href={`${withPrefix("/")}img/favicon-32x32.png`}
          sizes="32x32"
        />
        <link
          rel="icon"
          type="image/png"
          href={`${withPrefix("/")}img/favicon-16x16.png`}
          sizes="16x16"
        />

        {/*<link*/}
        {/*  rel="mask-icon"*/}
        {/*  href={`${withPrefix("/")}img/safari-pinned-tab.svg`}*/}
        {/*  color="#ff4400"*/}
        {/*/>*/}
        <meta name="theme-color" content="#fff" />

        <meta property="og:locale" content="en_US" />
        <meta property="og:type" content="business.business" />
        <meta property="og:title" content={title} />
        <meta property="og:site_name" content={title} />
        <meta property="og:description" content={description} />
        <meta property="og:url" content="/" />
        <meta
          property="og:image"
          content={`${withPrefix("/")}img/og-image.jpg`}
        />
        <meta property="og:image:width" content="1241" />
        <meta property="og:image:height" content="774" />
        <meta name="facebook-domain-verification" content="xl48qgsmmr9vptmx8l5sca7qfno58p" />
      </Helmet>
      <TopLinkBar />
      <Navbar />
      <div>{children}</div>
      <Footer />
    </div>
  );
};

export default TemplateWrapper;
